import { Skeleton } from '@sola/ark-core/atoms/skeleton/skeleton.tsx';

import { SettingDivider } from '../../molecules/account-settings-section/account-settings-section.tsx';

type SectionSkeletonProps = {
  contentBlocks: number;
  includeProfile?: boolean;
};

const SectionSkeleton: React.FC<SectionSkeletonProps> = ({
  contentBlocks,
  includeProfile,
}) => {
  return (
    <section className="Settings flex flex-col gap-comfy-xl py-comfy-lg">
      <Skeleton height={25} width={120} />
      <div className="flex gap-snug-xl mb-comfy-lg md:mb-comfy-xl">
        <div className="flex flex-1 flex-col gap-comfy-lg md:flex-row">
          {Array.from({ length: contentBlocks }, (_, index) => (
            <div key={index} className="flex flex-col flex-1 gap-snug-xl">
              <Skeleton height={23} width={343} />
              <Skeleton height={23} width={343} />
            </div>
          ))}
          {includeProfile && (
            <div className="flex flex-1 gap-comfy-sm items-center">
              <Skeleton circle height={72} width={72} />
              <Skeleton height={54} width={256} />
            </div>
          )}
        </div>
        <div className="py-comfy-lg">
          <Skeleton height={20} width={40} />
        </div>
      </div>
    </section>
  );
};

export const AccountSettingsSkeleton: React.FC = () => {
  return (
    <div
      aria-busy="true"
      aria-label="Loading account settings"
      className="gap-comfy-xl"
    >
      <SectionSkeleton contentBlocks={2} />
      <SettingDivider />
      <SectionSkeleton contentBlocks={1} includeProfile />
      <SettingDivider />
      <SectionSkeleton contentBlocks={2} />
      <SettingDivider />
      <SectionSkeleton contentBlocks={1} />
      <SettingDivider />
      <SectionSkeleton contentBlocks={2} />
    </div>
  );
};
